import React from "react";
import styled, { css } from "styled-components";

const SliderForInstagram = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-start;
    align-content: flex-start;
    justify-content: center;
    flex-wrap: wrap;
`

SliderForInstagram.Cont = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-start;
    align-content: flex-start;
    justify-content: center;
    flex-wrap: wrap;
    padding: 90px 0px 40px;

    @media (max-width: 500px){
        padding: 50px 0px 40px;
    }

    @media (max-width: 800px){
        .container 
        {
            padding: 0px;
        }
    }

`

SliderForInstagram.Title = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-start;
    align-content: flex-start;
    justify-content: center;
    margin-bottom: 60px;

    .root & 
    {
        h1,
        h2 
        {
            padding: 0;
            margin: 0px;
            width: auto;
            display: inline-block;
            font-size: 35px;
            font-weight: 300;
            line-height: 1.25;


            @media (max-width: 500px){
                font-size: 26px;
            }
        }
    }

    @media (max-width: 500px){
        margin-bottom: 45px;
    }
`

SliderForInstagram.Title.Badge = styled.div`
    /* background-color: #fe8651; */
    background-color: rgb(142 83 78);
    border-radius: 20px;
    text-align: center;
    color: #fff;
    padding-top: 3px;
    z-index: 2;
    position: static;
    display: inline-block;
    font-size: 13px;
    font-weight: 500;
    letter-spacing: -0.2px;
    height: auto;
    width: auto;
    padding: 3px 9px;
    min-width: 30px;
    margin: 13px 0px 0px 8px;

    @media (max-width: 500px){
        padding: 2px 7px;
        min-width: 28px;
        margin: 10px 0px 0px 7px;
    }
`


SliderForInstagram.Slider = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-start;
    align-content: flex-start;
    justify-content: center;
    flex-wrap: wrap;

    @media (max-width: 750px){
        display: none;
    }

    .root & 
    {
        .slick-slider
        {
            padding: 0px 30px;

            .slick-list
            {
                overflow: hidden;
            }

            .slider-control_left
            {
                left: 0px;
            }

            .slider-control_right
            {
                right: 0px;
            }

            @media (min-width: 1300px){
                .slick-track
                {
                    .slick-slide
                    {
                        &:not(only-child)
                        {
                            /* min-width: 550px; */
                        }
                    }
                }
            }

            @media (min-width: 700px){
                .slick-track
                {
                    padding: 0px 0px;

                    .slick-slide
                    {
                        padding: 0px 15px;
                    }
                }
            }

            @media (max-width: 800px){
                .slider-control_left
                {
                    left: 12px;
                }

                .slider-control_right
                {
                    right: 12px;
                }
            }

            @media (max-width: 600px)
            {
                .slider-control:before
                {
                    display: none;
                }
            }

            @media (max-width: 500px)
            {
                .slick-track
                {

                    .slick-slide
                    {
                        padding: 0px 15px;
                    }
                }
            }
        }
        
        /* .slick-slider 
        {
            display: flex;
            align-items: center;
            align-content: center;
            justify-content: center;
            flex-wrap: wrap;
            overflow: hidden;
            position: relative;
            margin: 0px;
    
            :before 
            {
                content: "";
                position: absolute;
                top: -400px;
                bottom: -400px;
                left: 0;
                width: 100%;
                z-index: 10;
                pointer-events: none;
                box-shadow: inset 0 0 120px 120px #fff;
                box-shadow: inset 0 0 90px 90px #fff;
            }
    
            .slick-list
            {
                float: left;
                overflow: visible;
                display: flex;
                align-items: flex-start;
                align-content: flex-start;
                justify-content: center;
                max-width: none;
                width: 590px;
    
                .slick-track
                {
                    display: flex;
                    justify-content: center;
    
                    .slick-slide 
                    {
                        width: 550px;
    
                        > div 
                        {
                            width: 100%;
                        }
                    }
                }
            }

            .slick-arrow 
            {
                position: absolute;
                top: 0px;
                bottom: 0px;
                width: 100px;
                z-index: 20;

                img 
                {
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    opacity: 0.7;
                    width: 27px;
                    height: 27px;
                    filter: brightness(1.02);
                    cursor: pointer;
                    transition: 0.25s;

                    :hover 
                    {
                        opacity: 1;
                    }
                }

                &.slick-prev
                {
                    left: 0px;

                    img 
                    {
                        left: 15px;
                    }
                }

                &.slick-next
                {
                    right: 0px;

                    img 
                    {
                        right: 15px;
                    }
                }
            }
        } */
    }
`

SliderForInstagram.Item = styled.div`
    /* padding: 20px 15px; */
    /* height: 100%; */
`

SliderForInstagram.Grid = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-start;
    align-content: flex-start;
    justify-content: center;
    flex-wrap: wrap;
    display: none;

    @media (max-width: 750px){
        display: flex;
    }
`

SliderForInstagram.GridItem = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-start;
    align-content: flex-start;
    justify-content: center;
    flex-wrap: wrap;
    margin-bottom: 15px;
`

SliderForInstagram.Grid.Action = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-start;
    align-content: flex-start;
    justify-content: center;
    flex-wrap: wrap;

    .btn 
    {
        margin-top: 20px;
        min-width: 200px;
    }
`


export default SliderForInstagram